import { productMasterApi } from './api';

export default async function exportProductMasterRequest({
	accessToken,
	mainCountryId,
	search,
	selectedBrand,
	selectedOwner,
	userFilter,
	paginationModel,
}) {
	const buildParams = (field, value) => {
		const params = new URLSearchParams();
		if (userFilter) params.append('categoryOwner', userFilter);
		if (selectedOwner && userFilter === null)
			params.append('categoryOwner', selectedOwner);
		if (mainCountryId) params.append('countryId', mainCountryId);
		if (search) params.append('sku', search);
		if (selectedBrand) params.append('brand', selectedBrand);
		if (paginationModel) {
			params.append('limit', paginationModel.pageSize);
			params.append('offset', paginationModel.page);
		}
		return params;
	};

	const params = buildParams(null, null);
	const res = await productMasterApi.get(
		`GetProductsDisabled?${params.toString()}`,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
				accept: '*/*',
			},
		}
	);
	return res?.data || [];
}
